import { Select } from 'antd';
import { SelectProps } from 'antd/lib/select';
import { isEmpty, noop } from 'lodash';
import React, { useMemo } from 'react';
import { useQuery } from 'react-query';
import { getMyParValues, getProductList } from 'services/parametersService';

type MyParValuesSelectProps = SelectProps<any> & {
  onSelected?: (value: any, option: any) => void;
  allowclear?: boolean;
};

const MyParValuesSelect = ({
  onChange = noop,
  onSelected = noop,
  allowclear,
  ...otherProps
}: MyParValuesSelectProps) => {
  const { data: products, isFetching } = useGetProductList();

  const { data: parvalues } = useQuery([getMyParValues], () =>
    getMyParValues({
      parcode: 'PRODUCT',
    }).then((response) => response.list || [])
  );

  const options: SelectProps<any>['options'] = useMemo(() => {
    const product = products?.map((product) => ({
      ...product,
      label: product.prlabel,
      value: product.prcode,
    }));
    const parval = parvalues?.map((val) => ({
      ...val,
      label: val.parvaluelabel,
      value: val.parvalue,
    }));

    const values = !isEmpty(parval) ? parval : product;
    
    return values;
  }, [products, parvalues]);

  const handleChange = (value: string, option: any) => {
    onChange(value, option);
    onSelected(value, option);
  };

  return (
    <Select
      allowClear={allowclear}
      options={options}
      loading={isFetching}
      {...otherProps}
      onChange={handleChange}
    />
  );
};

export default MyParValuesSelect;

export const useGetProductList = () => {
  return useQuery('getProductList', () =>
    getProductList().then((res) => res.list || [])
  );
};
